export const IMAGE_TYPE_SVG = 'svg';
export const MIME_TYPE_SVG = 'image/svg+xml';
